import { isNil } from 'lodash-es'
import React, { FunctionComponent } from 'react'

import {
  tDefaults,
  tFormats,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { WriskTrans } from '../trans'

interface IPTProps {
  amount?: number
  iptKey?: string
}

export const IPT: FunctionComponent<IPTProps> = ({ amount, iptKey }) => {
  const { t } = useWriskTranslation()
  const key =
    iptKey ?? (!isNil(amount) ? tDefaults('ipt.withTaxAmount') : tDefaults('ipt.default'))

  return (
    <WriskTrans
      t={t}
      i18nKey={key}
      values={{
        amount: t(tFormats('currency.long'), { amount }),
      }}
    />
  )
}
